import './styles.css';

/**
 * Placeholder de um conceito ainda em geração. Ocupa exatamente a mesma célula
 * do ConceptCard para que a substituição não desloque o grid.
 */
export default function ConceptCardSkeleton() {
    return (
        <div className="concept-card-skeleton" aria-hidden="true">
            <div className="concept-card-skeleton-image" />
            <div className="concept-card-skeleton-overlay">
                <div className="concept-card-skeleton-line" />
                <div className="concept-card-skeleton-line short" />
            </div>
        </div>
    );
}
